var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var pug_indent = [];
pug_html = pug_html + "\u003Ci class=\"icon fa-fw {{icon}}\" [style.color]=\"color\" *ngIf=\"!isHTML\"\u003E\u003C\u002Fi\u003E\n\u003Cdiv class=\"icon\" [fastHtmlBind]=\"icon\" *ngIf=\"isHTML &amp;&amp; icon\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;